export default {"src":"/_next/static/media/MANU.b9059ecf.svg","height":18,"width":18};